import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"elevation":"5"}},[_c(VCardTitle,{staticStyle:{"font-weight":"700","color":"#004d40","background-color":"#eee"}},[_vm._t("cardTitle")],2),_c(VCardSubtitle,{staticStyle:{"color":"#000","background-color":"#eee"}},[_vm._t("cardSubtitle")],2),_c(VCardText,{staticStyle:{"margin-bottom":"20px"}},[_vm._t("cardText")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }